import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { MedicationsVaccinesProvider } from "./MedicationsVaccinesContext";
import { MedicationsProductsScreen } from "./MedicationsProductsScreen/MedicationsProductsScreen";
import { VaccinesSelectScreen } from "./VaccinesSelectScreen/VaccinesSelectScreen";
import { VaccineDetailsScreen } from "./VaccineDetailsScreen/VaccineDetailsScreen";
import { MedicationsIntroScreen } from "./MedicationsIntroScreen/MedicationsIntroScreen";
import { MedicationDetailsScreen } from "./MedicationDetailsScreen/MedicationDetailsScreen";
import { MedicationsVaccinesCompleteScreen } from "./MedicationsVaccinesCompleteScreen/MedicationsVaccinesCompleteScreen";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type MedicationsVaccinesStackParamList = {
  MedicationsIntro: undefined;
  MedicationsProducts: undefined;
  MedicationDetails: undefined;
  VaccinesSelect: undefined;
  VaccineDetails: undefined;
  MedicationsVaccinesComplete: undefined;
};

export type MedicationsVaccinesStackScreenProps<
  T extends keyof MedicationsVaccinesStackParamList,
> = StackScreenProps<MedicationsVaccinesStackParamList, T>;

const Stack = createNativeStackNavigator<MedicationsVaccinesStackParamList>();

export function MedicationsVaccinesNavigator() {
  return (
    <MedicationsVaccinesProvider>
      <MedicalHistoryQuestionProvider
        section="medications-vaccines"
        sectionLabelKey="med_history.review.section_title.medications-vaccines"
        helpTextKey="med_history.question_screen.flow_help.medications-vaccines"
      >
        <Stack.Navigator
          initialRouteName="MedicationsIntro"
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen
            name="MedicationsIntro"
            component={MedicationsIntroScreen}
          />
          <Stack.Screen
            name="MedicationsProducts"
            component={MedicationsProductsScreen}
          />
          <Stack.Screen
            name="MedicationDetails"
            component={MedicationDetailsScreen}
          />
          <Stack.Screen
            name="VaccinesSelect"
            component={VaccinesSelectScreen}
          />
          <Stack.Screen
            name="VaccineDetails"
            component={VaccineDetailsScreen}
          />
          <Stack.Screen
            name="MedicationsVaccinesComplete"
            component={MedicationsVaccinesCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </MedicationsVaccinesProvider>
  );
}
